import { render, staticRenderFns } from "./NewItemNonMember.vue?vue&type=template&id=04b4bb20&scoped=true&"
import script from "./NewItemNonMember.vue?vue&type=script&lang=js&"
export * from "./NewItemNonMember.vue?vue&type=script&lang=js&"
import style0 from "./NewItemNonMember.vue?vue&type=style&index=0&id=04b4bb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4bb20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow,VSheet})
